import { render } from "./SingleTopic.vue?vue&type=template&id=9b322a2e&scoped=true"
import script from "./SingleTopic.vue?vue&type=script&lang=js"
export * from "./SingleTopic.vue?vue&type=script&lang=js"

import "./SingleTopic.vue?vue&type=style&index=0&id=9b322a2e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b322a2e"]])

export default __exports__